import { render, staticRenderFns } from "./factorySupplyList.vue?vue&type=template&id=008ab52d&scoped=true"
import script from "./factorySupplyList.vue?vue&type=script&lang=js"
export * from "./factorySupplyList.vue?vue&type=script&lang=js"
import style0 from "./factorySupplyList.vue?vue&type=style&index=0&id=008ab52d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008ab52d",
  null
  
)

export default component.exports